const success = value => `${value}_SUCCESS`;

const error = value => `${value}_ERROR`;

const reset = value => `${value}_RESET`;

export { success, error, reset };
